"use client";
import { useState } from "react";
import CampingCard from "./CampingCard";
import dynamic from "next/dynamic";
import { useVenueDetail } from "@/hooks/venueContext";

interface Props {
  campaigns: Campaign.Detail[];
  venue?: Venue.Detail;
  className?: string;
  titleHeadingLevel: "h2" | "h3";
}

const CampaignDetailModal = dynamic(
  () =>
    import("@/components/views/modals/event-and-campaign/CampaignDetailModal"),
);

export default function CampaignList(props: Props) {
  const [selectedCampaign, setSelectedCampaign] = useState<Campaign.Detail>(
    {} as Campaign.Detail,
  );
  const [modalOpen, setModalOpen] = useState(false);
  const { setVenue } = useVenueDetail();

  return (
    <>
      {Array.isArray(props.campaigns) &&
        props.campaigns?.map((campaign, index) => {
          return (
            <CampingCard
              titleHeadingLevel={props.titleHeadingLevel}
              key={index}
              onClick={() => {
                setSelectedCampaign({
                  ...campaign,
                  venue: props.venue ?? campaign.venue,
                });
                setModalOpen(true);
                setVenue(props.venue ?? (campaign.venue as Venue.Detail));
              }}
              {...campaign}
              venue={props.venue ?? campaign.venue}
            />
          );
        })}

      {modalOpen && (
        <CampaignDetailModal
          open={modalOpen}
          onClose={() => setModalOpen(false)}
          campaign={selectedCampaign}
        />
      )}
    </>
  );
}
